import React, { memo } from 'react';
import {
  Box,
  Typography,
  Button,
  Pagination,
} from '@mui/material';

interface SourcesListHeaderProps {
  recordsShown: number;
  totalCount: number;
  pageSize: number;
  currentPage: number;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
}

const SourcesListHeader = memo(({
  recordsShown,
  totalCount,
  pageSize,
  currentPage,
  onPageChange,
}: SourcesListHeaderProps) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h4" component="h1">
        Sources Library
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Typography variant="body1" color="text.secondary">
          Showing <strong>{recordsShown}</strong> of <strong>{totalCount}</strong> records
        </Typography>
        {totalCount > pageSize && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              size="small"
              onClick={(e) => onPageChange(e as any, 1)}
              disabled={currentPage === 1}
              title="Go to first page"
            >
              ⏮
            </Button>
            <Pagination
              count={Math.ceil(totalCount / pageSize)}
              page={currentPage}
              onChange={onPageChange}
              size="small"
              color="primary"
              siblingCount={1}
              boundaryCount={1}
            />
            <Button
              size="small"
              onClick={(e) => onPageChange(e as any, Math.ceil(totalCount / pageSize))}
              disabled={currentPage === Math.ceil(totalCount / pageSize)}
              title="Go to last page"
            >
              ⏭
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
});

SourcesListHeader.displayName = 'SourcesListHeader';

export default SourcesListHeader;
